import { createAsyncThunk } from "@reduxjs/toolkit";
import { logout } from "./LoginSlice";
import { logoutUser } from "./AccountLogoutThunk";

/**
 * fetch all Featuredvendors entries
 */
export const fetchFeaturedvendorsItems = createAsyncThunk(
  "featuredvendors/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/featuredvendors`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const addFeaturedvendors = createAsyncThunk(
  "featuredvendors/addItems",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data)
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/featuredvendors`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
      body: body
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateFeaturedvendors = createAsyncThunk(
  "featuredvendors/updateItems",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data)
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/featuredvendors?_id=${data._id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
      body: body
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateFeaturedVendorsList = createAsyncThunk(
  "featuredvendors/updateItemsList",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data)
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/featuredvendors/change-priority?_id=${data._id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
      body: body
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const deleteFeaturedvendors = createAsyncThunk(
  "featuredvendors/updateItems",
  async (data, thunkAPI) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/featuredvendors?_id=${data._id}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);